import Swiper from "swiper"
import runSlider from "../utils/runSlider"

function reviewSlider () {
    new Swiper (".review-slider .swiper-container", {
        slidesPerView: 3,
        loop: true,
        //grabCursor: true,
        //freeMode: true,
        spaceBetween: 30,
        autoplay: {
            delay: 3000
        },
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
        },
        breakpoints: {
            500: {
                slidesPerView: 1,
                spaceBetween: 30,
            },
            900: {
                slidesPerView: 3,
                spaceBetween: 30,
            },
        }
    })
}

function initSlider () {
    runSlider(".review-slider", reviewSlider)
}

export default initSlider